'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30(evaluator$20) {
  this.LZ = null;
  this.LZ = evaluator$20;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 as $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 as $h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 };
$h_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LZ.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30, "samples.Sealed$package$$anon$6$$anon$28$$anon$30", ({
  qw: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 as $d_Lsamples_Sealed$package$$anon$6$$anon$28$$anon$30 };
